import { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Auth, API } from 'aws-amplify';
import { userTypes } from '../constants';
import { UserContext } from '../utils/context';

function usePatientProfile(native = false) {
  const { loggedIn } = useContext(UserContext);
  const patientProfileRedux = useSelector(
    (state) => state.userReducer.patientProfile
  );
  const [patientProfile, setPatientProfile] = useState(
    patientProfileRedux || false
  );
  const dispatch = useDispatch();

  async function getPatientProfile() {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const userId = cognitoUser.attributes.sub;
      const salesForcePatient = await API.get('oshiAPI', `/users/${userId}`);
      dispatch({
        type: userTypes.STORE_PATIENT_PROFILE,
        patientProfile: salesForcePatient,
      });
      setPatientProfile(salesForcePatient);
      return salesForcePatient;
    } catch (error) {
      setPatientProfile(false);
      return error;
    }
  }

  useEffect(
    () => {
      if (!patientProfileRedux && loggedIn && !native) getPatientProfile();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [patientProfileRedux, loggedIn]
  );

  return { patientProfile, getPatientProfile };
}
export default usePatientProfile;
